import { Route, Routes } from "react-router-dom";
import EquipmentMonitoring from "pages/monitoring/equipment";
import EquipmentViewType2Monitoring from "pages/monitoring/equipment-view_type2";
import RouteAccessError from "pages/RouteAccessError";
import PermissionRoute from "components/route/PermissionRoute";
import { PERMISSIONS } from "config/permissions";

export default function MonitoringEquipmentRoutes(props) {

    return (
        <Routes>
            <Route path="/">
                <Route
                    index
                    element={
                        <PermissionRoute
                            permission={PERMISSIONS.FRONT_READ}
                        >
                            <EquipmentMonitoring />
                        </PermissionRoute>
                    }
                />
                <Route path=":id" 
                    element={ 
                        <PermissionRoute
                            permission={PERMISSIONS.FRONT_READ}
                        >
                            <EquipmentViewType2Monitoring />
                        </PermissionRoute> 
                    }
                 />
                <Route path="*" element={ <RouteAccessError /> }/>
            </Route>
        </Routes>
    );
}